<template>
  <form ref="newsletterForm" :id="'newsletter-input-form_' + _uid" method="post" @submit.prevent="validateData" class="newsletterInputForm">
    <div class="row" style="flex-direction:row-reverse;">
      <div class="col-6" v-if="showNameInputs">
        <div class="input-unit" data-validate="!regex">
          <label :for="'first-name-input_' + _uid">{{ $translate("Ceres::Template.newsletterFirstName") }}</label>
          <input type="text" data-validate-ref="/[.:\/\d]/g" :id="'first-name-input_' + _uid" v-model="firstName" data-testing="nl-first-name">
        </div>
      </div>
      <div class="col-6 pl-0" v-if="showNameInputs">
        <div class="input-unit" data-validate="!regex">
          <label :for="'last-name-input_' + _uid">{{ $translate("Ceres::Template.newsletterLastName") }}</label>
          <input type="text" data-validate-ref="/[.:\/\d]/g" :id="'last-name-input_' + _uid" v-model="lastName"  data-testing="nl-last-name">
        </div>
      </div>

      <div class="col-12">
        <div class="input-group">
          <div class="input-unit newsletter-input" data-validate="mail">
            <label :for="'email-input-id_' + _uid">{{ $translate("ETCeresCoconut::Template.etcNewsletterEMailText") }} {{ $translate("Ceres::Template.newsletterIsRequiredFootnote") }}</label>
            <input @focus="loadRecaptcha = true" type="email" autocomplete="email" :id="'email-input-id_' + _uid" v-model="email" data-testing="nl-mail">
          </div>
          <input autocomplete="none" class="honey" type="text" name="username" tabindex="-1" v-model="honeypot">
        </div>
      </div>

      <div class="col-12" v-if="showPrivacyPolicyCheckbox">
        <div class="form-check small newsletter-datenschutz" data-validate>
          <input type="checkbox" class="form-check-input" :id="'privacy-policy-accept-id_' + _uid" name="privacy-policy-accept"  style="height: unset" v-model="privacyPolicyValue" data-testing="nl-policy">
          <label :for="'privacy-policy-accept-id_' + _uid" class="form-check-label" v-html="privacyPolicyText"></label>
        </div>
      </div>

      <div class="col-md-9 col-12 newsletter-button">
        <div class="input-group-btn">
          <button type="button" class="btn btn-block btn-secondary btn-appearance" @click="validateData" :disabled="isDisabled" :class="buttonSizeClass" data-testing="nl-send">
            {{ $translate("ETCeresCoconut::Template.etcNewsletterButtonAboText") }}
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15">
              <path id="envelope-solid" d="M19.621,68.953a.235.235,0,0,1,.379.184v7.988A1.875,1.875,0,0,1,18.125,79H1.875A1.875,1.875,0,0,1,0,77.125V69.141a.234.234,0,0,1,.379-.184c.875.68,2.035,1.543,6.02,4.438.824.6,2.215,1.867,3.6,1.859,1.395.012,2.813-1.281,3.605-1.859C17.59,70.5,18.746,69.633,19.621,68.953ZM10,74c.906.016,2.211-1.141,2.867-1.617,5.184-3.762,5.578-4.09,6.773-5.027A.935.935,0,0,0,20,66.617v-.742A1.875,1.875,0,0,0,18.125,64H1.875A1.875,1.875,0,0,0,0,65.875v.742a.94.94,0,0,0,.359.738c1.2.934,1.59,1.266,6.773,5.027C7.789,72.859,9.094,74.016,10,74Z" transform="translate(0 -64)" fill="#fff"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <recaptcha v-if="!!$ceres.config.global.googleRecaptchaApiKey && loadRecaptcha"></recaptcha>
  </form>
</template>

<script>
import ApiService from "../../services/ApiService";
import NotificationService from "../../services/NotificationService";
import ValidationService from "../../services/ValidationService";
import { executeReCaptcha } from "../../helper/executeReCaptcha";
import { ButtonSizePropertyMixin } from "../../mixins/buttonSizeProperty.mixin";

export default {
    mixins: [ButtonSizePropertyMixin],

    props: {
        showNameInputs:
        {
            type: Boolean,
            default: false
        },
        showPrivacyPolicyCheckbox:
        {
            type: Boolean,
            default: true
        },
        emailFolder:
        {
            type: Number,
            default: 0
        }
    },

    data()
    {
        return {
            firstName: "",
            lastName: "",
            email: "",
            isDisabled: false,
            privacyPolicyValue: false,
            honeypot: "",
            loadRecaptcha: false
        };
    },

    computed:
    {
        privacyPolicyText()
        {
            const link = "<a href=\"" + App.urls.privacyPolicy + "\" target=\"_blank\"><span class=\"text-primary text-appearance\">"
                + this.$translate("Ceres::Template.checkoutPrivacyPolicy", {"hyphen": "&shy;"})
                + "</span></a>";

            return this.$translate("Ceres::Template.newsletterAcceptPrivacyPolicy", {"policy": link}) + this.$translate("Ceres::Template.newsletterIsRequiredFootnote");
        }
    },

    methods: {
        validateData()
        {
            this.isDisabled = true;

            ValidationService.validate($("#newsletter-input-form_" + this._uid))
                .done(() =>
                {
                    this.save();
                })
                .fail(invalidFields =>
                {
                    ValidationService.markInvalidFields(invalidFields, "error");

                    invalidFields.filter(field => {
                        return field.dataset.validate !== null
                    }).map((field) => {
                        return {
                            type: field.dataset.validate,
                            name: field.innerText
                        }
                    }).forEach((field) => {
                        if(field.type === '!regex')
                        {
                            NotificationService.error(this.$translate("Ceres::Template.newsletterNotAllowedCharacters", {name: field.name}));
                        }
                    });

                    this.isDisabled = false;
                });
        },

        save()
        {
            const recaptchaEl = this.$el.querySelector("[data-recaptcha]");

            if (App.config.global.googleRecaptchaApiKey && (!window.grecaptcha || !recaptchaEl))
            {
                NotificationService.error(this.$translate("Ceres::Template.newsletterAcceptRecaptchaCookie"));
                this.isDisabled = false;
                return;
            }

            executeReCaptcha(this.$el)
            .then((recaptchaToken) =>
            {
                ApiService.post("/rest/io/customer/newsletter", { email: this.email, firstName: this.firstName, lastName: this.lastName, emailFolder: this.emailFolder, honeypot: this.honeypot, recaptcha: recaptchaToken})
                    .done(data =>
                    {
                        if (!!data.containsHoneypot)
                        {
                            NotificationService.warn(
                                this.$translate("Ceres::Template.newsletterHoneypotWarning")
                            );
                        }
                        else
                        {
                            NotificationService.success(
                                this.$translate("Ceres::Template.newsletterSuccessMessage")
                            ).closeAfter(3000);
                        }
                        this.resetInputs();
                    })
                    .fail(() =>
                    {
                        NotificationService.error(
                            this.$translate("Ceres::Template.newsletterErrorMessage")
                        ).closeAfter(5000);
                    })
                    .always(() =>
                    {
                        this.isDisabled = false;
                        this.resetRecaptcha();
                    });
            });
        },

        resetInputs()
        {
            this.firstName = "";
            this.lastName = "";
            this.email = "";
            this.privacyPolicyValue = false;
        },

        resetRecaptcha()
        {
            if(App.config.global.googleRecaptchaVersion === 2 && window.grecaptcha)
            {
                const recaptchaId = this.$el.querySelector("[data-recaptcha]");

                window.grecaptcha.reset(recaptchaId);
            }
        },

    }
}
</script>
